import { pickBy } from "lodash"

function toSnakeCase(str: string) {
  return str.replace(/[A-Z]/g, match => `_${match.toLowerCase()}`)
}

const hasOwnProperty = <T>(obj: T, prop: string) => {
  return Object.prototype.hasOwnProperty.call(obj, prop)
}

const removeEmptyValues = <T>(obj: T) => {
  const transformedObject = {} as Record<string, string | number | boolean | (string | number | boolean)[]>

  for (const key in obj) {
    if (hasOwnProperty(obj, key)) {
      const snakeCaseKey = toSnakeCase(key)
      const param = obj[key]

      if (Array.isArray(param)) {
        const arrayValues: (string | number | boolean)[] = []
        param.forEach(item => {
          if (item != null && typeof item === "object" && hasOwnProperty(item, "value")) {
            // customParamsSerializer is called from api.ts
            // baseQueryWithAuth function that is transforming params to string
            arrayValues.push(item.value)
          } else if (item != null) {
            arrayValues.push(item)
          }
        })
        if (arrayValues.length > 0) {
          transformedObject[snakeCaseKey] = arrayValues
        }
      } else if (param != null && typeof param === "object" && hasOwnProperty(param, "value")) {
        // @ts-expect-error hasOwnProperty checks for value
        transformedObject[snakeCaseKey] = param.value
      } else if (param != null) {
        transformedObject[snakeCaseKey] = param as string | number | boolean
      }
    }
  }

  return pickBy(transformedObject, value => {
    if (Array.isArray(value)) {
      return value.length > 0
    }
    return value !== ""
  })
}

export const customParamsSerializer = (
  params: Record<string, string | number | boolean | (string | number | boolean)[]>,
): string => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(item => {
        searchParams.append(`${key}[]`, String(item))
      })
    } else if (value != null) {
      searchParams.append(key, String(value))
    }
  })

  return searchParams.toString()
}

export const prepareQueryParams = <T>(obj: T) => {
  return removeEmptyValues(obj)
}
